import imgRegular from "../assets/images/allproducts/boards/regularcropped.png";
import imgMousture from "../assets/images/allproducts/boards/mousturecropped.svg";
import imgMoisture from "../assets/images/allproducts/boards/moisturecropped.svg";
import imgFire from "../assets/images/allproducts/boards/firecropped.svg";
import imgFmr from "../assets/images/allproducts/boards/fmrcropped.svg";
import imgExterior from "../assets/images/allproducts/boards/exteriorcropped.svg";

const defaultTabBodies = (name) => ({
  specifications: `Technical specifications for ${name} are available on request. Contact IRQGYP for thickness options, board dimensions, and performance data aligned to your project.`,
  recommendations: `Installation should follow manufacturer guidance and local codes. ${name} is suitable where its performance characteristics match the exposure and substrate conditions of the application.`,
  sustainability: `IRQGYP focuses on responsible sourcing and efficient use of materials. Ask our team for environmental documentation relevant to ${name}.`,
  downloads: `Datasheets and safety information for ${name} can be requested through our downloads area or your IRQGYP representative.`,
});

export const boardsDetailById = {
  regular: {
    id: "regular",
    heroTag: "GYPSUM BOARD",
    heroTitle: "Regular",
    heroDescription:
      "Regular gypsum board is a factory-manufactured, paper-faced gypsum plasterboard designed for general internal wall and ceiling linings in dry, conditioned environments.",
    heroDescriptionMore:
      " It is intended for non-load-bearing partitions and ceilings where fire, acoustic, or moisture ratings are not required beyond standard lining performance.",
    heroImage: imgRegular,
    tabBodies: {
      ...defaultTabBodies("Regular gypsum board"),
      specifications:
        "Nominal thicknesses typically include 9.5 mm and 12.5 mm; board edges are tapered or square depending on the system. Face paper supports joint treatment and decoration after priming.",
    },
    keyFeatures: [
      "General-purpose interior board for partitions and ceilings",
      "Rapid installation and ease of finishing",
      "Paper-faced surface provides good paint and cladding adhesion after priming",
      "Lightweight panels reduce loads on building structure",
      "Compatible with standard metal framing and screw-fixing patterns",
      "Suitable for direct decoration after joint treatment and preparation",
    ],
  },
  mousture: {
    id: "mousture",
    heroTag: "GYPSUM BOARD",
    heroTitle: "Mousture",
    heroDescription:
      "Aquaguard gypsum board is a factory-manufactured gypsum plasterboard engineered for internal walls in humid environments.",
    heroDescriptionMore:
      " Enhanced core additives help resist moisture compared with standard boards in intermittent humidity applications.",
    heroImage: imgMousture,
    tabBodies: defaultTabBodies("Aquaguard"),
    keyFeatures: [
      "Engineered for humid internal environments",
      "Compatible with moisture-aware finishing systems",
      "Supports rapid enclosure of wet areas when detailed correctly",
      "Works with standard metal framing and accessories",
    ],
  },
  moisture: {
    id: "moisture",
    heroTag: "GYPSUM BOARD",
    heroTitle: "Moisture",
    heroDescription:
      "AL AHLI H3 MR gypsum board is a factory-manufactured gypsum plasterboard engineered for internal walls with moisture resistance.",
    heroDescriptionMore:
      " Use where enhanced moisture performance is specified by the designer.",
    heroImage: imgMoisture,
    tabBodies: defaultTabBodies("AL AHLI H3 MR"),
    keyFeatures: [
      "Moisture-resistant core formulation",
      "Suitable for conditioned interiors with controlled humidity",
      "Paper-facing ready for jointing and decoration",
      "Coordinate with compatible membranes and trims",
    ],
  },
  fire: {
    id: "fire",
    heroTag: "GYPSUM BOARD",
    heroTitle: "Fire",
    heroDescription:
      "Fire Resistant (FR) gypsum board is a factory-manufactured, paper-faced gypsum plasterboard with a non-combustible core.",
    heroDescriptionMore:
      " Specify where fire resistance contributes to the overall passive protection strategy.",
    heroImage: imgFire,
    tabBodies: defaultTabBodies("Fire Resistant (FR)"),
    keyFeatures: [
      "Non-combustible gypsum core with glass fibre reinforcement",
      "Supports fire-rated partitions and ceilings when used in tested systems",
      "Paper faces suitable for joint treatment and decoration",
      "Coordinate with tested studs, channels, and penetration detail",
    ],
  },
  fmr: {
    id: "fmr",
    heroTag: "GYPSUM BOARD",
    heroTitle: "FMR",
    heroDescription:
      "Fire & Moisture Resistant Gypsum Board (FMR) is a factory-manufactured, paper-faced gypsum plasterboard engineered for demanding conditions.",
    heroDescriptionMore:
      " Combines attributes needed where both fire strategy and moisture exposure are considerations.",
    heroImage: imgFmr,
    tabBodies: defaultTabBodies("FMR"),
    keyFeatures: [
      "Dual-purpose performance for selected interior applications",
      "Supports documented lining systems when installed as tested",
      "Prepare surfaces per manufacturer guidance before finishing",
      "Use compatible fasteners and cavity management",
    ],
  },
  exterior: {
    id: "exterior",
    heroTag: "GYPSUM BOARD",
    heroTitle: "Exterior",
    heroDescription:
      "ShieldEx Glass Mat Gypsum Sheathing Board is an exterior-grade gypsum panel with fiberglass mat facings and a non-combustible core.",
    heroDescriptionMore:
      " Designed for sheathing applications behind approved claddings and weather barriers.",
    specificationsDescription:
      "ShieldEx Glass Mat Gypsum Sheathing Board is an exterior-grade gypsum panel with fiberglass mat facings and a non-combustible, water-resistant gypsum core. It is specifically designed as a substrate for exterior cladding and weather barrier systems, providing dimensional stability, mold resistance, and enhanced durability. The product is manufactured and tested in accordance with EN 15283-1 for gypsum boards with mat reinforcement and is comparable in intended use to ASTM C1177 glass mat gypsum sheathing.",
    heroImage: imgExterior,
    tabBodies: defaultTabBodies("ShieldEx"),
    keyFeatures: [
      "Glass-mat facings for exterior exposure behind cladding",
      "Non-combustible core suitable for sheathing strategies",
      "Coordinate with WRB and structural fixing patterns",
      "Follow engineered details for openings and transitions",
    ],
  },
};

export function getBoardDetailById(id) {
  if (!id) return undefined;
  return boardsDetailById[id];
}
